// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"486":"9f9c5499","607":"5c4ecf23"}[chunkId] + ".chunk.js");